module.exports = __webpack_public_path__ + "img/linkPharmacyLogo.03fece94.png";